import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Base subjects of a module, e.g. "Account-List" -> Cash, Bank, ...
export const getSubjects = async (moduleType) => {
  try {
    const response = await axios.get(`${BASE_URL}/accountListSub/getSubject`, {
      params: { account_selected: moduleType },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
